module.exports = __webpack_public_path__ + "img/oneRed.cae7015d.jpg";